import styled from "styled-components";
import { ICON_LQS, ICON_QIH, ICON_TBR } from "../../../utils/icons";
import { th } from "../../../utils/helpers";
import { useDashboardContext } from "../../../context/dashboard_context";
import { StyledIcon } from "../../../styles";
import { useEffect } from "react";
import MiniLoader from "../../../utils/MIniLoader";



const InventorySummary = () => {

      const {
            inventoryOverviewLoading, inventoryOverviewData, getInventoryOverviewData,
      } = useDashboardContext();

      const { totalQuantity, lowQuantity } = inventoryOverviewData;

      useEffect(() => {
            getInventoryOverviewData();
      }, []);

      const sales = [
            { title: 'Quantity in Hand', icon: ICON_QIH, amount: totalQuantity, color: '#DBA362', border: 'border-end' },
            { title: 'To be received', icon: ICON_TBR, amount: 0, color: '#817AF399', border: 'border-end' },
            { title: 'Low Quantity Stock', icon: ICON_LQS, amount: lowQuantity, color: '#AA3028CC', border: '' },
      ];
      return (
            <StyledInventorySummary>
                  <div className="main-container">
                        <div className="d-flex gap-2">

                              <h4 className="grey-bold-text mb-4">
                                    Inventory Summary
                              </h4>
                              <MiniLoader
                                    load={inventoryOverviewLoading}
                              />
                        </div>
                        <div className="row justify-content-center">
                              {
                                    sales?.map(({ title, icon, amount, color, border }, i) =>
                                          <div className={`col-md-4 col-6 px-3 mb-3 text-center ${ border }`} key={i}>
                                                <StyledIcon
                                                      color={color}
                                                >
                                                      {icon}
                                                </StyledIcon>
                                                <div className="grey-text">
                                                      <h4 className="small m-0"> {th(amount || 0)} </h4>
                                                      <p className="small"> {title}</p>
                                                </div>
                                          </div>
                                    )
                              }
                        </div>
                  </div>
            </StyledInventorySummary>
      );
};

export default InventorySummary;

const StyledInventorySummary = styled.div`
      


`;